import { useState } from 'react';

import { useDomainsStore } from '../../../hooks';

import { AddApiKeysModal } from '../modals';

import { Box, MenuItem, Select, Button, styled } from '@mui/material';

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  background-color: black;
  margin: 10px 0;
  padding: 5px 20px;
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
`;

const StyledButton = styled(Button)`
  min-width: 150px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const StyledSelect = styled(Select)`
  min-width: 200px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const AdminPanel = ({ setUserName }) => {
  const { buyersList } = useDomainsStore();

  const [openModal, setOpenModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState('');

  const handleOpenModal = () => setOpenModal(true);

  return (
    <StyledBox>
      <StyledSelect
        onChange={(e) => {
          setUserName(e.target.value);
          setSelectedBuyer(e.target.value);
        }}
        value={selectedBuyer || 'Выберите пользователя'}
      >
        <MenuItem value='Выберите пользователя' disabled>
          Выберите пользователя
        </MenuItem>
        {buyersList.map((buyer) => (
          <MenuItem key={buyer._id} value={buyer.login}>
            {buyer.login}
          </MenuItem>
        ))}
      </StyledSelect>

      <StyledButton variant='contained' color='primary' onClick={handleOpenModal}>
        Добавить API ключи
      </StyledButton>

      <AddApiKeysModal openModal={openModal} setOpenModal={setOpenModal} />
    </StyledBox>
  );
};
